import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	YEAR_GRID_COLUMNS,
	YEARS_IN_DECADE,
} from "web_myplann/Shared/Components/FlatRow/datePanelHelpers";
import { FlatRowDatePanelGrid } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelGrid";
import { FlatRowDatePanelHeader } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelHeader";
import { FlatRowDateYearList } from "web_myplann/Shared/Components/FlatRow/FlatRowDateYearList";
import { getDecadeGridYears } from "web_myplann/Shared/Components/FlatRow/getDecadeGridYears";
import { getDecadeStart } from "web_myplann/Shared/Components/FlatRow/getDecadeStart";
import { isDecadeStepEnabled } from "web_myplann/Shared/Components/FlatRow/isDecadeStepEnabled";

type Props = {
	year: number;
	selectedYear: number | null;
	minDate?: Date;
	maxDate?: Date;
	onYearChange: (year: number) => void;
	onSelect: (year: number) => void;
};

export const FlatRowDateYearView: FC<Props> = ({
	year,
	selectedYear,
	minDate,
	maxDate,
	onYearChange,
	onSelect,
}) => {
	const { t } = useResource();

	const decadeStart = getDecadeStart(year);

	return (
		<>
			<FlatRowDatePanelHeader
				title={`${decadeStart} – ${decadeStart + YEARS_IN_DECADE - 1}`}
				previousLabel={t(Resources.Common.DatePicker.previousDecade)}
				nextLabel={t(Resources.Common.DatePicker.nextDecade)}
				previousEnabled={isDecadeStepEnabled(year, -1, minDate, maxDate)}
				nextEnabled={isDecadeStepEnabled(year, 1, minDate, maxDate)}
				onPrevious={() => onYearChange(year - YEARS_IN_DECADE)}
				onNext={() => onYearChange(year + YEARS_IN_DECADE)}
			/>
			<FlatRowDatePanelGrid columns={YEAR_GRID_COLUMNS}>
				<FlatRowDateYearList
					years={getDecadeGridYears(year)}
					decadeStart={decadeStart}
					value={selectedYear}
					minDate={minDate}
					maxDate={maxDate}
					onSelect={onSelect}
				/>
			</FlatRowDatePanelGrid>
		</>
	);
};
